<template>
    <div class="stepper-input">
        <SquareBtn :disabled="!decrementEnabled"
                   :color="color"
                   :size="size"
                   @click="decrement">
            <i class="fa-solid fa-minus"></i>
        </SquareBtn>
        <input type="number"
               :value="modelValue"
               class="form-control"
               :class="inputClasses"
               @input="onInput" />
        <SquareBtn :disabled="!incrementEnabled"
                   :color="color"
                   :size="size"
                   @click="increment">
            <i class="fa-solid fa-plus"></i>
        </SquareBtn>
    </div>
</template>

<script>
import SquareBtn from '@/vue/components/SquareBtn';

export default {
    components: { SquareBtn },

    props: {
        color: {
            type: String,
            default: 'default',
        },

        size: {
            type: String,
            default: null,
        },

        modelValue: {
            type: Number,
            default: 0,
        },

        max: {
            type: Number,
            default: null,
        },

        min: {
            type: Number,
            default: null,
        },
    },

    emits: [
        'update:modelValue',
    ],

    computed: {
        incrementEnabled() {
            return !(this.max !== null && this.modelValue >= this.max);
        },

        decrementEnabled() {
            return !(this.min !== null && this.modelValue <= this.min);
        },

        inputClasses() {
            const classes = [];

            if (this.size) {
                classes.push('input-' + this.size);
            }

            return classes;
        },
    },

    methods: {
        setValue(newValue) {
            if (this.min !== null && newValue < this.min) {
                return false;
            }

            if (this.max !== null && newValue > this.max) {
                return false;
            }

            // Emit the new value.
            this.$emit('update:modelValue', newValue);
            return true;
        },

        increment() {
            this.setValue(this.modelValue + 1);
        },

        decrement() {
            this.setValue(this.modelValue - 1);
        },

        onInput($event) {
            const eventValue = parseInt($event.target.value || 0);
            if (!this.setValue(eventValue)) {
                // Restore the old value.
                $event.target.value = this.modelValue;
            }
        },
    },
};
</script>

<style lang="less">
@import "../../../less/variables";

.stepper-input {
    display: flex;
    grid-gap: @half-gutter-width;

    > .btn {
        flex-grow: 0;
        flex-shrink: 0;
        height: auto;
        min-width: 50px;
    }

    > input {
        flex-grow: 1;
        flex-shrink: 1;
        height: auto;
        width: 100% !important;
        text-align: center;
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
